module.exports = __webpack_public_path__ + "static/media/GPremium-brand.8809d8bf.svg";